import _axios from '../util/axios/AxiosConfig'

export function getUsers(params){
  return _axios({
    url: '/api/User/GetUsers',
    method: 'get',
    params:params
  })
}

export function getUserDetail(userId){
  return _axios({
    url: `/api/ERPCommon/GetUserDetail?userId=${userId}`,
    method: 'get'
  })
}
